import {
  type BucketCustomization,
  type SemanticLegendSettingsWithCategoricalConfig,
} from '../../types';
import {DEFAULT_SEMANTIC_LEGEND_SETTINGS} from '../SemanticLegendDefaults';

export function resetColors(
  semanticLegendSettings: SemanticLegendSettingsWithCategoricalConfig
) {
  const newBucketCustomizations: Record<number, BucketCustomization> = {};
  const buckets = semanticLegendSettings?.buckets;
  if (buckets) {
    for (let i = 0; i < buckets.length; i++) {
      const bucketCustomization =
        semanticLegendSettings?.bucketCustomizations?.[i];
      if (bucketCustomization?.bucketMax) {
        newBucketCustomizations[i] = {
          bucketMax: bucketCustomization.bucketMax,
        };
      }
    }
  }
  return {
    ...semanticLegendSettings,
    bucketCustomizations: newBucketCustomizations,
    excludedRunColor: DEFAULT_SEMANTIC_LEGEND_SETTINGS.excludedRunColor,
  };
}
